import CrmServiceModel from '@/models/CrmServiceModel'

export default class CustomerFieldModel extends CrmServiceModel {
  modelName () {
    return 'customer-fields'
  }

  publicRoutes () {
    const routes = super.publicRoutes() || {}
    routes.create = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName()
    routes.exists = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/' + this.modelName() + '/exists'
    return routes
  }

  defaults () {
    return {
      id: null,
      name: null,
      //
      customer_id: null,
      customer_grower_id: null,
      customer: null,
      customer_grower: null,
      //
      created_at: null,
      updated_at: null,
      deleted_at: null
    }
  }

  // Attribute mutations.
  mutations () {
    return {
      id: (val) => (this.nullStringMutator(val))
    }
  }

  // Attribute validation
  validation () {
    return {}
  }

  routes () {
    const base_route = process.env.VUE_APP_CRM_REPOSITORY_URL + '/api/v1/'
    const routes = super.routes()
    routes.exists = base_route + this.modelName() + '/exists'
    return routes
  }

  exists () {
    const payload = this.attributes
    const config = {
      method: this.getMethod('create'),
      url: this.getURL(this.getRoute('exists')),
      data: payload
    }
    return this.createRequest(config).send().then((response) => {
      if (response.response.status === 200) {
        return true
      } else if (response.response.status === 204) {
        return false
      }
    })
  }
}
